import { withOverrideLegacy } from '~/App/hocs/with-override-legacy';

import { Podcasts } from './Podcasts'
import { loadData } from './Podcasts.LoadData';

export default withOverrideLegacy(Podcasts, loadData);